const pad = (n) => String(n).padStart(2, "0");

export const ymd = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;

export function mondayOf(d) {
  const x = new Date(d);
  x.setDate(x.getDate() - ((x.getDay() + 6) % 7));
  return x;
}

export function addDays(d, n) {
  const x = new Date(d);
  x.setDate(x.getDate() + n);
  return x;
}

export function rangeFor(mode, anchor) {
  const a = new Date(anchor);
  if (mode === "WEEK") {
    const s = mondayOf(a);
    return { start: ymd(s), end: ymd(addDays(s, 6)) };
  }
  if (mode === "MONTH") {
    return { start: ymd(new Date(a.getFullYear(), a.getMonth(), 1)), end: ymd(new Date(a.getFullYear(), a.getMonth() + 1, 0)) };
  }
  if (mode === "QUARTER") {
    const q = Math.floor(a.getMonth() / 3);
    return { start: ymd(new Date(a.getFullYear(), q * 3, 1)), end: ymd(new Date(a.getFullYear(), q * 3 + 3, 0)) };
  }
  if (mode === "YEAR") {
    return { start: `${a.getFullYear()}-01-01`, end: `${a.getFullYear()}-12-31` };
  }
  return null;
}

export function shiftAnchor(mode, anchor, dir) {
  const a = new Date(anchor);
  if (mode === "WEEK") return addDays(a, dir * 7);
  if (mode === "MONTH") return new Date(a.getFullYear(), a.getMonth() + dir, 1);
  if (mode === "QUARTER") return new Date(a.getFullYear(), a.getMonth() + dir * 3, 1);
  if (mode === "YEAR") return new Date(a.getFullYear() + dir, 0, 1);
  return a;
}

const fmtShort = (iso) =>
  new Date(`${iso}T00:00:00`).toLocaleDateString("en-NZ", { day: "numeric", month: "short", year: "numeric" });

export function rangeLabel(mode, range, anchor) {
  if (!range?.start) return "";
  const a = new Date(anchor);
  if (mode === "MONTH") return a.toLocaleDateString("en-NZ", { month: "long", year: "numeric" });
  if (mode === "QUARTER") return `Q${Math.floor(a.getMonth() / 3) + 1} ${a.getFullYear()}`;
  if (mode === "YEAR") return String(a.getFullYear());
  return `${fmtShort(range.start)} – ${fmtShort(range.end)}`;
}

export function weekDays(range) {
  const days = [];
  let d = new Date(`${range.start}T00:00:00`);
  const end = new Date(`${range.end}T00:00:00`);
  while (d <= end && days.length < 7) {
    days.push(ymd(d));
    d = addDays(d, 1);
  }
  return days;
}

export const dayLabel = (iso) =>
  new Date(`${iso}T00:00:00`).toLocaleDateString("en-NZ", { weekday: "long", day: "numeric", month: "short" });

export const money = (n) =>
  `$${Number(n || 0).toLocaleString("en-NZ", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
